import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { BodyComponent } from './body/body.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AssociationDetailsComponent } from './association-details/association-details.component';
import { MaterialModule } from './material.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DatePipe } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { DynamicTabsService } from './dynamic-tabs.service';
import { SublevelMenuComponent } from './sublevel-menu/sublevel-menu.component';
import { AssociationsModule } from './associations/associations.module';
import { MasterpoliciesModule } from './masterpolicies/masterpolicies.module';
import { MainModule } from './main/main.module';
import { GuidesModule } from './guides/guides.module';
import { NavbarComponent } from './navbar/navbar.component';
import { NoAcessComponent } from './no-acess/no-acess.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MyPaginatorIntl } from './MyPaginatorIntl';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AddHeaderInterceptor } from './services/AddHeaderInterceptor';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

@NgModule({
  declarations: [
    AppComponent,
    SidenavComponent,
    BodyComponent,
    SublevelMenuComponent,
    NavbarComponent,
    AssociationDetailsComponent,
    NoAcessComponent

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    FontAwesomeModule,
    MatTabsModule,
    AssociationsModule,
    MainModule,
    MasterpoliciesModule,
    GuidesModule,
    MatTabsModule,
    MatPaginatorModule,
    MatSnackBarModule,
    MatSortModule,
    MatDatepickerModule, 
    MatNativeDateModule, 
  ],

  providers: [
    {provide:MatPaginatorIntl,useClass:MyPaginatorIntl},
    DatePipe, DynamicTabsService,
     {provide:HTTP_INTERCEPTORS, useClass:AddHeaderInterceptor, multi:true}
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule { }
